import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

export default function Benefits() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const benefits = [
    {
      icon: 'fa-solid fa-chart-line',
      title: 'Resultados Medibles',
      description: 'Incremento promedio del 150% en tráfico orgánico en los primeros 6 meses',
      bgColor: 'bg-gradient-to-br from-cyan-50 to-blue-50',
      color: 'bg-cyan-500'
    },
    {
      icon: 'fa-solid fa-robot',
      title: 'Tecnología IA Avanzada',
      description: 'Optimización continua con algoritmos de machine learning',
      bgColor: 'bg-gradient-to-br from-purple-50 to-pink-50',
      color: 'bg-purple-500'
    },
    {
      icon: 'fa-solid fa-shield-halved',
      title: 'Garantía de Calidad',
      description: 'Cumplimiento 100% de las directrices de Google y mejores prácticas',
      bgColor: 'bg-gradient-to-br from-green-50 to-emerald-50',
      color: 'bg-green-500'
    },
    {
      icon: 'fa-solid fa-clock',
      title: 'Ahorro de Tiempo',
      description: 'Automatización de tareas repetitivas para enfocarte en tu negocio',
      bgColor: 'bg-gradient-to-br from-orange-50 to-amber-50',
      color: 'bg-orange-500'
    },
    {
      icon: 'fa-solid fa-headset',
      title: 'Soporte Dedicado',
      description: 'Equipo de expertos disponible para resolver tus dudas',
      bgColor: 'bg-gradient-to-br from-teal-50 to-cyan-50',
      color: 'bg-teal-500'
    },
    {
      icon: 'fa-solid fa-trophy',
      title: 'Ventaja Competitiva',
      description: 'Posicionamiento superior frente a tu competencia',
      bgColor: 'bg-gradient-to-br from-yellow-50 to-orange-50',
      color: 'bg-yellow-500'
    }
  ];

  return (
    <section ref={ref} className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 sm:mb-16"
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-black mb-4 px-4">
            Por Qué Elegir Nuestra <span className="text-cyan-500">Automatización SEO</span>
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            Tecnología de vanguardia que combina IA generativa, optimización técnica avanzada y monitorización continua para resultados excepcionales
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className={`${benefit.bgColor} rounded-3xl p-6 sm:p-8 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100 group`}
            >
              <div className={`w-14 h-14 sm:w-16 sm:h-16 ${benefit.color} rounded-2xl flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${benefit.icon} text-white text-3xl sm:text-4xl`}></i>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2 sm:mb-3">{benefit.title}</h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{benefit.description}</p>
            </motion.div>
          ))}
        </div>

        {/* Stats Bar */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.8 }}
          className="mt-16 sm:mt-20 bg-cyan-500 rounded-3xl p-8 sm:p-12"
        >
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 text-center text-white">
            <div>
              <div className="text-3xl sm:text-4xl md:text-5xl font-bold mb-2">+500</div>
              <div className="text-sm sm:text-base md:text-lg opacity-90">Sitios Optimizados</div>
            </div>
            <div>
              <div className="text-3xl sm:text-4xl md:text-5xl font-bold mb-2">98%</div>
              <div className="text-sm sm:text-base md:text-lg opacity-90">Satisfacción Cliente</div>
            </div>
            <div>
              <div className="text-3xl sm:text-4xl md:text-5xl font-bold mb-2">+250%</div>
              <div className="text-sm sm:text-base md:text-lg opacity-90">Incremento Medio Tráfico</div>
            </div>
            <div>
              <div className="text-3xl sm:text-4xl md:text-5xl font-bold mb-2">24/7</div>
              <div className="text-sm sm:text-base md:text-lg opacity-90">Soporte Técnico</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
